import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { AnalyticsKPI } from "@/types/analytics";

interface KpiGridProps {
  data: AnalyticsKPI;
}

const KPI_ITEMS = [
  { key: "clicks" as const, label: "Clicks", color: "text-[var(--chart-1)]" },
  {
    key: "uniques" as const,
    label: "Unique Clicks",
    color: "text-[var(--chart-2-fg)]",
  },
  {
    key: "conversions" as const,
    label: "Conversions",
    color: "text-[var(--chart-3-fg)]",
  },
  {
    key: "revenue" as const,
    label: "Revenue",
    color: "text-[var(--chart-4-fg)]",
    format: (v: number) => `€${v.toFixed(2)}`,
  },
  {
    key: "uepc" as const,
    label: "uEPC",
    color: "text-[var(--chart-5-fg)]",
    format: (v: number) => `€${v.toFixed(4)}`,
  },
] as const;

export const KpiGrid = ({ data }: KpiGridProps) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-5">
      {KPI_ITEMS.map((item) => {
        const raw = data?.[item.key] ?? 0;
        const display =
          "format" in item && item.format
            ? item.format(raw)
            : raw.toLocaleString();

        return (
          <Card key={item.key}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {item.label}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div
                className={`text-2xl font-bold tabular-nums tracking-tight ${item.color}`}
              >
                {display}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
